module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n      © Designed with\n      "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by\n      Pit"), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v("Format"), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v("Boys\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38e9e6d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/ContentFooter.vue
// module id = 475
// module chunks = 1